import React from 'react'
import { FaCoins, FaShoppingCart, FaUser } from 'react-icons/fa'
import { MdLogout } from 'react-icons/md'
import { Link, useParams } from 'react-router'
import MainHeader from '../../Components/Header/MainHeader'
import MainHeaderRedemption from '../../Components/Header/MainHeaderRedemption'
import UserProfileNavigator from '../../Components/User/UserProfileNavigator'
import AllClientOrders from '../Shopping/AllClientOrders'
import ClientOrderDetails from '../Shopping/ClientOrderDetails'
import OrderHistory from '../Shopping/OrderHistory'
import RedemptionOrderDetails from '../Shopping/RedemptionOrderDetails'
import PointsHistory from './PointsHistory'
import Profile from './Profile'
import styles from './UserProfileHolder.module.css'

const UserProfileHolder = () => {
    const { ebType, identifier } = useParams()

    console.log(ebType, identifier)
    return (
        <div>
            <MainHeaderRedemption />
            <div className={styles.mainWrapper}>
                <div className={styles.leftWrapper} >
                    <UserProfileNavigator />
                </div>
                {ebType === "user" &&
                    <div className={styles.rightWrapper}>
                        {identifier === 'profile' && <Profile />}
                        {identifier === 'orders' && <AllClientOrders />}
                        {identifier === 'order' && <ClientOrderDetails />}
                    </div>
                }
                {ebType === "points" &&
                    <div className={styles.rightWrapper}>
                        {identifier === 'transactions' && <PointsHistory />}
                        {identifier === 'orders' && <OrderHistory />}
                        {identifier === 'order' && <RedemptionOrderDetails />}
                    </div>
                }

            </div>
        </div>
    )
}

export default UserProfileHolder